import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        nombres: "",
        idCargo: 0,
        idEstado: 2,
    },
    listCargo: [],
    listEstado: [],
    results: [],
}

export const trabajadorSearchSlice = createSlice({
    name: "trabajadorSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        setListCargo: (state, action) => {
            state.listCargo = action.payload;
        },
        setListEstado: (state, action) => {
            state.listEstado = action.payload;
        },
    },
});

export const { setValue, setResults, setListCargo, setListEstado } = trabajadorSearchSlice.actions;
export default trabajadorSearchSlice.reducer;